import React, { useEffect, useState } from "react";
import Spline from "@splinetool/react-spline";

function ConveyorScene() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  if (loading) {
    return (
      <div className="absolute top-0 left-0 z-10 flex items-center justify-center w-full h-full text-white">
        Loading
      </div>
    );
  }

  return (
    <div className="relative h-[95vh] -translate-y-10 w-full">
      <Spline scene="https://prod.spline.design/BE0RjUetaGhDt-ep/scene.splinecode" />
      <div className="absolute bottom-0 right-0 h-20 bg-black w-96"></div>
    </div>
  );
}

export default ConveyorScene;
